// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__2nsN5","header":"Card_header__34OJL","body":"Card_body__1eIzM","footer":"Card_footer__2Uc4n"};